import { render, staticRenderFns } from "./ExamType.vue?vue&type=template&id=6e5c1d8b&scoped=true&"
import script from "./ExamType.vue?vue&type=script&lang=js&"
export * from "./ExamType.vue?vue&type=script&lang=js&"
import style0 from "./ExamType.vue?vue&type=style&index=0&id=6e5c1d8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5c1d8b",
  null
  
)

export default component.exports